var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50048",
    "data-name": "Path 50048",
    d: "M99.375,183.794H96.011L88.5,182.637,90.675,182H94.7a6.752,6.752,0,0,1,3.919,1.256Z",
    transform: "translate(-88.5 -182)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29384",
    "data-name": "Group 29384",
    transform: "translate(-154 -262.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(154 262.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_12_",
    "data-name": "svgexport-17 (12)",
    transform: "translate(169 274.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50030",
    "data-name": "Path 50030",
    d: "M22.9,170.511H21.009l-1.987-1.345A6.707,6.707,0,0,0,15.238,168H10.516L5,169.682v.605h.493v1.928H5v1.525l.785,1.031H26.973V173.7l.538-1.224-1.036-.776A5.937,5.937,0,0,0,22.9,170.511Z",
    transform: "translate(-5 -168)",
    fill: "#db3328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50031",
    "data-name": "Path 50031",
    d: "M9.215,182H8.457L5,183.054l.933.022Z",
    transform: "translate(-5 -181.372)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50032",
    "data-name": "Path 50032",
    d: "M285.9,182h-.5l2.753,1.883h.682l-1.987-1.35A5.492,5.492,0,0,0,285.9,182Z",
    transform: "translate(-272.826 -181.372)",
    fill: "#747e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50033",
    "data-name": "Path 50033",
    d: "M26.973,223.484H5.785L5,222.453H26.973ZM6.466,220.928H5.493V219h.973l.471,1.1Z",
    transform: "translate(-5 -216.713)",
    fill: "#b5100b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50034",
    "data-name": "Path 50034",
    d: "M99.375,183.794H96.011L88.5,182.637,90.675,182H94.7a6.752,6.752,0,0,1,3.919,1.256Z",
    transform: "translate(-84.756 -181.372)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50035",
    "data-name": "Path 50035",
    d: "M171.8,234.83l-7.305-.435-1.39-1.749,1.453-.646,7.108,1.076a.4.4,0,0,1-.444.4l-6.13-.7-.543.269.758.718,6.153.682A.38.38,0,0,1,171.8,234.83Z",
    transform: "translate(-156.01 -229.13)",
    fill: "#b5100b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50036",
    "data-name": "Path 50036",
    d: "M476,263h1.39v.448H476Z",
    transform: "translate(-454.879 -258.74)",
    fill: "#ebeadf"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 2.184,
    cy: 2.184,
    rx: 2.184,
    ry: 2.184,
    transform: "translate(1.767 3.525)",
    fill: "#323d2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50037",
    "data-name": "Path 50037",
    d: "M81.3,246.543a2.076,2.076,0,0,0-.529.04.161.161,0,0,0,.036.318h.031a2.2,2.2,0,0,1,2.184,2.184v.031a.161.161,0,0,0,.318.036,2.282,2.282,0,0,0,.04-.529,2.189,2.189,0,0,0-2.081-2.081Z",
    transform: "translate(-77.255 -243.018)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50038",
    "data-name": "Path 50038",
    d: "M47.51,266.513a2.194,2.194,0,0,1-2.04-2.04v-.027a.413.413,0,0,0-.758-.206,2.165,2.165,0,0,0-.363,1.314,2.187,2.187,0,0,0,3.395,1.718.413.413,0,0,0-.206-.758Z",
    transform: "translate(-42.582 -259.746)",
    fill: "#1c2617"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_434",
    "data-name": "Ellipse 434",
    cx: 1.072,
    cy: 1.072,
    rx: 1.072,
    ry: 1.072,
    transform: "translate(2.879 4.637)",
    fill: "#747e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50039",
    "data-name": "Path 50039",
    d: "M89.531,271.328a1.146,1.146,0,0,0-.175,0,.09.09,0,0,0,0,.179h.013a1.079,1.079,0,0,1,.96.96v.013a.09.09,0,0,0,.179,0,1.139,1.139,0,0,0,0-.175A1.075,1.075,0,0,0,89.531,271.328Z",
    transform: "translate(-85.495 -266.691)",
    fill: "#c4c1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50040",
    "data-name": "Path 50040",
    d: "M70.58,283.572a1.068,1.068,0,0,1-.942-.942v-.013a.212.212,0,0,0-.4-.076,1.076,1.076,0,0,0,.892,1.529,1.054,1.054,0,0,0,.534-.1.211.211,0,0,0-.076-.4Z",
    transform: "translate(-66.262 -277.294)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50041",
    "data-name": "Path 50041",
    d: "M22,219h.345v1.928H22Z",
    transform: "translate(-21.238 -216.713)",
    fill: "#e67368"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_435",
    "data-name": "Ellipse 435",
    cx: 2.184,
    cy: 2.184,
    rx: 2.184,
    ry: 2.184,
    transform: "translate(16.305 3.525)",
    fill: "#323d2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50042",
    "data-name": "Path 50042",
    d: "M371.71,266.513a2.194,2.194,0,0,1-2.04-2.04v-.027a.413.413,0,0,0-.758-.206,2.165,2.165,0,0,0-.363,1.314,2.187,2.187,0,0,0,3.395,1.718.413.413,0,0,0-.206-.758Z",
    transform: "translate(-352.243 -259.746)",
    fill: "#1c2617"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_436",
    "data-name": "Ellipse 436",
    cx: 1.072,
    cy: 1.072,
    rx: 1.072,
    ry: 1.072,
    transform: "translate(17.408 4.637)",
    fill: "#747e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50043",
    "data-name": "Path 50043",
    d: "M405.3,246.543a2.075,2.075,0,0,0-.529.04.161.161,0,0,0,.036.318h.031a2.2,2.2,0,0,1,2.184,2.184v.031a.161.161,0,0,0,.318.036,2.286,2.286,0,0,0,.04-.529A2.189,2.189,0,0,0,405.3,246.543Z",
    transform: "translate(-386.726 -243.018)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50044",
    "data-name": "Path 50044",
    d: "M413.531,271.328a1.145,1.145,0,0,0-.175,0,.09.09,0,0,0,0,.179h.013a1.079,1.079,0,0,1,.96.96v.013a.09.09,0,0,0,.179,0,1.146,1.146,0,0,0,0-.175A1.075,1.075,0,0,0,413.531,271.328Z",
    transform: "translate(-394.966 -266.691)",
    fill: "#c4c1ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50045",
    "data-name": "Path 50045",
    d: "M394.58,283.572a1.068,1.068,0,0,1-.942-.942v-.013a.212.212,0,0,0-.4-.076,1.076,1.076,0,0,0,.892,1.529,1.054,1.054,0,0,0,.534-.1.211.211,0,0,0-.076-.4Z",
    transform: "translate(-375.733 -277.294)",
    fill: "#485143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50046",
    "data-name": "Path 50046",
    d: "M16.256,197.716h3.363l1.39.09h3.924a6.227,6.227,0,0,0-2.031-.359H21.009l-1.39-.09H16.256L8.74,196.2,5,196.617V197l3.744-.3Z",
    transform: "translate(-5 -194.935)",
    fill: "#e67368"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28923",
    "data-name": "Group 28923",
    transform: "translate(3.744 0.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28922",
    "data-name": "Group 28922",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50047",
    "data-name": "Path 50047",
    d: "M136.1,176.283h-.8l-2.6-2.583h.8Zm2.426,0h-1.677l-2.6-2.583h1.673Z",
    transform: "translate(-130.718 -174.072)",
    fill: "#747e6c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_50049",
    "data-name": "Path 50049",
    d: "M175.715,183.377l-.915-.143V182h.915Z",
    transform: "translate(-167.186 -181.372)",
    fill: "#323d2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50050",
    "data-name": "Path 50050",
    d: "M5,205.5h.933",
    transform: "translate(-5 -203.818)",
    fill: "#485143"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarHighlighted);
export default __webpack_public_path__ + "static/media/CarHighlighted.5895e6c936b7f6d615be4b494ae8fb2c.svg";
export { ForwardRef as ReactComponent };